'use client'
import React from 'react'

import { useNavContext } from './nav-context-provider'
import { NavCtaButton } from './nav-cta-button'
import { Close, Search } from './nav-topbar'

// Desktop only - the search icon and cta button
export const NavTopbarRight: React.FC = () => {
  const navContext = useNavContext()
  const searchContainer = navContext.nav.containers.find((c) => c.type === 'search')!
  const searchOpen = searchContainer.id === navContext.current.containerId

  return (
    <section className="right flex min-h-[2.813rem] items-center justify-end gap-[10px]">
      <section className="search hidden nav:flex gap-2">
        <NavCtaButton />
        {searchOpen ? (
          <Close className="cursor-pointer" onClick={() => navContext.clear()} />
        ) : (
          <Search className="cursor-pointer" onClick={() => navContext.set({ container: searchContainer })} />
        )}
      </section>
    </section>
  )
}
